import { Component, OnInit } from '@angular/core';
import {AppService} from '../app.service';
import {AppDatashareservice} from '../app.datashareservice';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-featured',
  templateUrl: './featured.component.html',
  styleUrls: ['./featured.component.scss']
})
export class FeaturedComponent implements OnInit {

  contentList: any;
  tweaksFeaturedList: any;
  exDesc: any;

  constructor(
    private _appService: AppService,
    private _appDataService: AppDatashareservice,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {

    this.spinner.show();
    this._appDataService.currentData.subscribe(data => this.exDesc = data);
    this._appService.getContentListByPageName('featured').subscribe(res => {
      this.contentList = res;
      this.spinner.hide();
    });

    this._appService.getTweaksAndExtensions().subscribe(res => {
      this.tweaksFeaturedList = res;
      this.spinner.hide();
    });

  }

  descDataFeatured (exDescAll: any) {
    this._appDataService.changeData(exDescAll);
  }

}
